module.exports = __webpack_public_path__ + "img/area.0c163645.svg";